import type { FormLabelProps as _FormLabelProps } from "@chakra-ui/react";
import { forwardRef, FormLabel as _FormLabel } from "@chakra-ui/react";

export interface FormLabelProps extends _FormLabelProps {}

export const FormLabel = forwardRef<FormLabelProps, "div">(({ ...props }, ref) => (
    <_FormLabel ref={ref} mb="2" lineHeight={["base", "default"]} {...props} />
));
